import React from "react";
import styled, { keyframes } from "styled-components";
import { Container, Section, Eyebrow } from "../components/ui/Container";
import { colors, fonts, media } from "../theme";

const partners = [
  {
    name: "Uganda Microfinance Regulatory Authority",
    role: "Money lending licence",
    img: "UMRA.png",
  },
  {
    name: "Uganda Registration Services Bureau",
    role: "Company registration",
    img: "URSB-LOGO.png",
  },
  {
    name: "Personal Data Protection Office",
    role: "Data protection registration",
    img: "personal_data_protection.png",
  },
  {
    name: "Ministry of ICT and National Guidance",
    role: "National ICT framework",
    img: "ministry_of_ict.png",
  },
  {
    name: "National ICT Innovation Hub",
    role: "Innovation hub partner",
    img: "national_ict_innovation_hub.png",
  },
];

export const Partners = () => (
  <Section tight style={{ background: "white" }}>
    <Container>
      <Head>
        <Eyebrow>Licensed, regulated and supported</Eyebrow>
        <h2>The institutions behind our work.</h2>
        <p>
          Everpesa is a fully registered Ugandan company, licensed as a money
          lender, registered for data protection, and supported by Uganda's
          national innovation ecosystem.
        </p>
      </Head>
    </Container>

    <Track aria-label="Regulators and partners">
      <Row>
        {[...partners, ...partners].map((p, i) => (
          <Item key={i}>
            <ImgBox>
              <img src={process.env.PUBLIC_URL + "/images/" + p.img} alt={p.name} />
            </ImgBox>
            <Caption>
              <strong>{p.name}</strong>
              <span>{p.role}</span>
            </Caption>
          </Item>
        ))}
      </Row>
    </Track>
  </Section>
);

const Head = styled.div`
  text-align: center;
  max-width: 720px;
  margin: 0 auto 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  h2 { font-family: ${fonts.display}; }
  p { font-size: 16.5px; color: ${colors.inkMuted}; }
  ${media.sm} { margin-bottom: 32px; }
`;

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const Track = styled.div`
  overflow: hidden;
  padding: 8px 0;
  mask-image: linear-gradient(90deg, transparent, black 6%, black 94%, transparent);
  -webkit-mask-image: linear-gradient(90deg, transparent, black 6%, black 94%, transparent);
`;

const Row = styled.div`
  display: inline-flex;
  gap: 56px;
  align-items: stretch;
  animation: ${scroll} 60s linear infinite;
  padding: 0 28px;

  &:hover { animation-play-state: paused; }

  ${media.sm} { gap: 36px; }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex: 0 0 auto;
  width: 220px;

  ${media.sm} { width: 180px; }
`;

const ImgBox = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: grayscale(1) opacity(0.78);
  transition: filter 280ms ease, transform 280ms ease;

  img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }

  ${Item}:hover & {
    filter: grayscale(0) opacity(1);
    transform: scale(1.04);
  }

  ${media.sm} { height: 64px; }
`;

const Caption = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 200px;

  strong {
    font-size: 12px;
    font-weight: 600;
    color: ${colors.ink};
    line-height: 1.3;
  }
  span {
    font-size: 11px;
    color: ${colors.inkSoft};
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
`;
